import {
  applyTelegramMiniAppSettings,
  consumeTelegramMiniAppAuthEvent,
  getTelegramMiniApp,
  getTelegramMiniAppInitData,
  hasTelegramMiniAppRuntime,
  markTelegramMiniAppDocument,
} from 'common/utils/telegram-mini-app.js'
import { useVfmModals } from 'hooks/modals.js'
import { useTelegramStore } from 'src/stores/telegram'
import { useUserAuthStore } from 'src/stores/user/auth'
import { consoleLogAPI } from 'src/common/functions'
import { watchGlobalVariable } from 'src/core/init/watch-global/index.js'

export function useTelegramMiniApp({ onLogin } = {}) {
  const telegramStore = useTelegramStore()
  const userAuthStore = useUserAuthStore()
  const { telegramMiniAppModal } = useVfmModals()

  function hasAuth() {
    return Boolean(userAuthStore.getAuth || userAuthStore.getToken)
  }

  function syncTelegramMiniApp() {
    if (!hasTelegramMiniAppRuntime()) {
      return false
    }

    markTelegramMiniAppDocument()
    applyTelegramMiniAppSettings()
    telegramStore.isTelegramMiniApp = true

    if (consumeTelegramMiniAppAuthEvent()) {
      onLogin && onLogin()
    }

    return true
  }

  function shouldInitTelegramMiniApp() {
    return hasTelegramMiniAppRuntime() && !hasAuth()
  }

  async function initTelegramMiniApp() {
    try {
      if (!hasTelegramMiniAppRuntime()) {
        return
      }

      const initDataCandidate = getTelegramMiniAppInitData({ preferStorage: true })

      if (initDataCandidate) {
        syncTelegramMiniApp()

        if (!hasAuth()) {
          telegramMiniAppModal.open()
        }

        return
      }

      await watchGlobalVariable('Telegram')

      const telegramMiniApp = getTelegramMiniApp()

      if (!telegramMiniApp) {
        return
      }

      syncTelegramMiniApp()

      const initData = getTelegramMiniAppInitData({ preferStorage: true })

      if (hasAuth() || !initData) {
        return
      }

      telegramMiniAppModal.open()
    } catch (error) {
      consoleLogAPI(error)
    }
  }

  return {
    initTelegramMiniApp,
    shouldInitTelegramMiniApp,
    syncTelegramMiniApp,
  }
}
